import { NewUser } from 'models/user';
import { Api } from './api';
import { message } from 'antd';
import { Organization } from 'models/organization';

export function setFrontendVersionCookie(version: string) {
  const isSecure = window.location.protocol === 'https:';
  document.cookie = `frontend_version=${version}; domain=.bugal.com.au; path=/; ${isSecure ? 'secure;' : ''} samesite=lax`;
}

// TODO: Could be a shared library
interface MeResponse {
  user: NewUser;
}

export interface PutMeRequest {
  firstName: string;
  lastName: string;
  gender: string;
  dob: Date;
  phoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  idCountry: string;
  idState: string;
  timezone: string;
  bankName: string;
  bankBsb: string;
  bankAccountNumber: string;
}

export interface PatchMeRequest {
  firstName: string;
  lastName: string;
}

export async function GetMe() {
  const result = await Api.get<any, MeResponse>('/me');
  if (result.user) {
    // FIXME: Review if we still need to do something else here?
    // result.user.completed = !!(result.user.bankAccountNumber && result.user.timezone && result.user.abn);
    result.user.completed = !!(result.user.bankAccountNumber && result.user.timezone);
    if (result.user.frontendVersion) {
      setFrontendVersionCookie(result.user.frontendVersion);
    }
  }
  return result;
}

export async function GetOrganization() {
  const result = await Api.get<any, Organization>('/me/organization');
  return result;
}

export async function UpdateMe(data: PutMeRequest) {
  const result = await Api.put<PutMeRequest, MeResponse>('/me', data);
  message.success('Profile updated successfully');
  return result;
}

export async function PatchMe(data: PatchMeRequest) {
  const result = await Api.patch<PatchMeRequest, MeResponse>('/me', data);
  return result;
}
